<template>
  <app-layout>
    <template #main-content>
      <main id="content" class="l-main p-chapter">
        <div v-if="!workStore.isValidWorks">
          <loading-page></loading-page>
        </div>
        <div v-else class="l-main__inner">
          <div class="c-page-header">
            <div
               :class="{['c-page-header__bg c-page-header__bg--'+globalNavigationStore.selectedMenu]: true}">
            </div>
            <h1 class="c-page-header-title -small"><markdown-view :rawText="getChapterIndexTitle" :souruby="accountStore.isSouruby"/></h1>
            <div class="c-page-header__return">
              <a href="javascript:void(0)" class="c-button-white -return" @click="goBack()" name="S3-3-back-btn">
                <span class="label">
                  戻る
                </span>
              </a>
            </div>
            <p :class="{['p-chapter__subject -'+globalNavigationStore.selectedMenu]: true}">
              <span class="label">{{ getSubjectFieldName }}<span class="year" v-if="getSubjectFieldName==='歴史' && getAcademicYear===2">2・3</span>
              <span class="year" v-else-if="getSubjectFieldName!=='公民'">{{ getAcademicYear }}</span>
              </span>
            </p>
          </div>
          <!-- .p-chapter-filteringに.-invisibleを付与すると、要復習のみを表示トグルを非表示にする -->
          <div class="p-chapter-filtering">
            <p class="p-chapter-filtering-text">要復習のみを表示する</p>
            <div :class="{'c-parts-toggle':true,'c-parts-toggle--active': isReviewOnly}" @click="reviewToggleSwitch()" name="review-toggle-switch">
              <span class="label">{{isReviewOnly?'ON':'OFF'}}</span>
              <span class="toggle"></span>
            </div>  
          </div>
          <div class="c-question-block-wrap">
            <div :class="{['c-question-block c-question-block--review -'+globalNavigationStore.selectedMenu]: true}"
              v-if="numOfQuestion>0">
              <span class="c-parts-review">要復習</span>
              <div class="c-question-block__inner">
                <div class="blockReview">
                  <div class="title">
                    <ruby>問題<rp>(</rp><rt>もんだい</rt><rp>)</rp></ruby>をまとめて<ruby>解<rp>(</rp><rt>と</rt><rp>)</rp></ruby>く
                  </div>
                  <div class="count">
                    問題数<span class="label">{{numOfQuestion}}</span>問
                  </div>
                  <div class="button">
                    <div class="c-button-blue -small" @click="openReviewTagModal" name="S3-3-review-all-btn">
                      <span class="label -pen">
                        復習する
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bgReview">
                <div class="bgReview__inner">
                </div>
              </div>
              <div class="bgReview">
                <div class="bgReview__inner">
                </div>
              </div>
            </div>
          </div>
          
          <ul class="c-question">
            <li
              v-for="(section, index) in getSections" :ref="(el) => {refSection[section.id] = el}"
              :class="{'c-question__item c-question__item--detail':true,'c-question__item--clear':isAnimated(section.id)}">
              <chapter-accordion
                      :ref="(el) => {refChapterAccordion[section.id] = el}"
                      :section="section"
                      :is-open="section.id===accordionIsOpen(section.id)"
                      :selected-menu="globalNavigationStore.selectedMenu"
                      :old-section-progress="workStore.sectionProgress"
                      :review-tags="workStore.reviewTags"
                      :is-souruby="accountStore.isSouruby"
                      :homework-questionsets="homeworkStore.homeworkQuestionSets"
                      @open-section-review="openSectionReview"
                      @open-question-modal="openModal"
                      @open-interruption-modal="openInterruptionModal"
                      @is-open-accordion="saveAccordion"
              >
              </chapter-accordion>
            </li>
          </ul>
          <div v-if="workStore.sections.length>0">
            <!-- study interruption modal start -->
            <popup-modal v-model="interruptionModal" @close-layer="interruptionModal = false" @close="interruptionModal = false" name="interruption-btn">
              <template #main>
                <div class="c-popup-body__head">
                  <p class="c-popup-body__head-title">
                    中断した学習を再開しますか？
                  </p>
                </div>
                <div class="c-popup-body__titleBox">
                  <div class="c-popup-body__titleBox-logout">
                    中断した学習の続きから再開することができます。
                  </div>
                </div>
              </template>
              <template #footer>
                <div class="c-button -col2">
                  <a @click="openModal({section: selectedSection, question_set: selectedQuestionSet})" class="c-button-white -medium -font-large" name="S3-3-start-from-beginning-btn">
                    <span class="label">最初から学習</span>
                  </a>
                  <button-blue @click="startInterruptDataLearning()" :medium="true" :label-normal="true" name="S3-3-resume-from-last-btn">続きから再開</button-blue>
                </div>
              </template>
            </popup-modal>
            <popup-modal v-model="questionModal" @close="closeModal(null)" @close-layer="closeQuestionLayer()" :subject="globalNavigationStore.selectedMenu" name="close-btn">
              <template #label>
                <span class="c-parts-review" v-if="isReview(selectedQuestionSet.id)">要復習</span>
                <span class="c-parts-homework" v-if="homeworkQuestionset">宿題</span>
              </template>
              <template #main>
                <div class="c-popup-body__chapter">
                  <span class="c-parts-label -large">{{sectionReviewSortOrder}}</span>
                  <div class="c-popup-body__chapter-title">
                    <markdown-view :rawText="selectedSection.title" :souruby="accountStore.isSouruby"></markdown-view>
                  </div>
                </div>
                <div class="c-popup-body__titleBox">
                  <div class="c-popup-body__titleBox-title">
                    <div class="titleBlock">
                      <div class="c-parts-frame-wrapper">
                        <span v-if="questionSetDisplayName" :class="{'c-parts-frame -question':true, '-application':questionSetDisplayName == '応用問題'}">{{questionSetDisplayName}}</span>
                      </div>
                      <div class="title">
                        <markdown-view :rawText="selectedQuestionSet.title" :souruby="accountStore.isSouruby"></markdown-view>
                      </div>
                      <div class="count">全<span class="label">{{workStore.questions.length}}</span>問</div>
                    </div>
                  </div>
                  <div class="c-popup-body__titleBox-body">
                    <div class="c-parts-text-page" v-if="selectedQuestionSet.textbook_page_range">P {{selectedQuestionSet.textbook_page_range}}</div>
                    <div class="empty" v-else></div>
                    <div class="c-parts-last-learning -popup">
                      <p class="c-parts-last-learning__history" v-if="lastStudy(selectedSection.id, selectedQuestionSet.id).last_studied_at!==''">
                        <span class="label">前回の学習</span>
                        <span class="date">
                          <span class="num">{{parseInt(lastStudy(selectedSection.id, selectedQuestionSet.id).last_studied_at.slice(5,7))}}</span>月
                          <span class="num">{{parseInt(lastStudy(selectedSection.id, selectedQuestionSet.id).last_studied_at.slice(8,10))}}</span>日
                        </span>
                      </p>
                      <three-stars :number-of-stars="lastStudy(selectedSection.id, selectedQuestionSet.id).progress_stars"></three-stars>
                    </div>
                  </div>
                  <div class="c-parts-homework-information" v-if="homeworkInfo.length !=0">
                    <div class="c-parts-homework-information-item" v-for="homework in homeworkInfo">
                      <div class="c-parts-homework-information-label">宿題</div>
                      <div class="c-parts-homework-information-limit"><span>{{ homework.month }}</span>月<span>{{ homework.day }}</span>日({{ homework.dayOfWeek }}) <span>{{ homework.time }}</span>まで</div>
                      <div class="c-parts-homework-information-status">
                        <div class="c-parts-homework-status" :class="{[homework.statusClass]: true}">{{ homework.status }}</div>
                        <div class="c-parts-pin">{{ homework.achievement }}</div>
                        <div class="c-parts-pin -row" v-if="homework.relearning">{{ homework.relearning }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #footer>
                <template v-if="workStore.totalNumOfQuestion>unansweredQuestion.length ||
                          lastStudy(selectedSection.id, selectedQuestionSet.id).progress_stars >0">
                  <button-blue :full="true" @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, isReview(selectedQuestionSet.id)?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" name="start-learning-btn">全問題を学習</button-blue>
                  <div class="c-button -col2">
                    <button-white :full="true" @click="solveUnansweredQuestion" :disabled="unansweredQuestion.length===0" name="unanswered-question-btn">
                      未正解の問題だけ学習<span class="remaining">({{unansweredQuestion.length}}問)</span>
                    </button-white>
                    <button-white :full="true" @click="solvedReviewRequired()" :disabled="isReview(selectedQuestionSet.id)===0" name="review-question-btn">
                      要復習問題だけ学習<span class="remaining">({{isReview(selectedQuestionSet.id)}}問)</span>
                    </button-white>
                  </div>
                  <div class="btnBlock__single">
                    <a :class="{'textLink':true,'-disabled': !disabledLearning || workStore.latestQuestionHistories.length===0}"
                       @click="showQuestionHistories(isReview(selectedQuestionSet.id)?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" href="javascript:void(0)" name="learning-history-btn">
                      前回の学習結果を確認
                    </a>
                  </div>
                </template>
                <template v-else>
                  <button-blue :full="true" @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, isReview(selectedQuestionSet.id)?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" name="start-learning-btn">始める</button-blue>
                </template>
              </template>
            </popup-modal>
          </div>
          <!--Review tag modal-->
          <div v-if="numOfQuestion>0">
            <popup-modal v-model="reviewTagModal" @close="closeModal('reviewTag')" @close-layer="reviewTagModal=false" :subject="globalNavigationStore.selectedMenu" name="all-review-close-btn">
              <template #label><span class="c-parts-review">要復習</span></template>
              <template #main>
                <div class="c-popup-body__chapter">
                  <span class="c-parts-label -large">{{getChapter.index_label}}</span>
                  <div class="c-popup-body__chapter-title">
                    <markdown-view :rawText="getChapter.title" :souruby="accountStore.isSouruby"></markdown-view>
                  </div>
                </div>
                <div class="c-popup-body__titleBox">
                  <div class="c-popup-body__titleBox-title">
                    <div class="titleBlock -review">
                      <div class="title">
                        要復習問題
                      </div>
                      <div class="count">全<span class="label">{{numOfQuestion}}</span>問</div>
                    </div>
                  </div>
                </div>
              </template>
              <template #footer>
                <button-blue :full="true" @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, REVIEW_REQUIRED.CHAPTER_REVIEW)" name="all-review-start-learning-btn">要復習問題だけ学習</button-blue>
              </template>
            </popup-modal>
          </div>
          <!--Section review modal-->
          <popup-modal v-model="sectionTagModal" @close="closeModal('sectionReviewTag')"
                       @close-layer="sectionTagModal=false" :subject="globalNavigationStore.selectedMenu" name="section-review-close-btn">
            <template #label><span class="c-parts-review">要復習</span></template>
            <template #main>
              <div class="c-popup-body__chapter">
                <span class="c-parts-label -large">{{ sectionReviewSortOrder }}</span>
                <div class="c-popup-body__chapter-title">
                  <markdown-view :rawText="sectionReviewTitle" :souruby="accountStore.isSouruby"></markdown-view>
                </div>
              </div>
              <div class="c-popup-body__titleBox">
                <div class="c-popup-body__titleBox-title">
                  <div class="titleBlock -review">
                    <div class="title">
                      要復習問題
                    </div>
                    <div class="count">全<span class="label">{{ sectionReviewQuestionLen }}</span>問</div>
                  </div>
                </div>
              </div>
            </template>
            <template #footer>
              <button-blue :full="true" @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, REVIEW_REQUIRED.SECTION_REVIEW)" name="section-review-start-learning-btn">要復習問題だけ学習</button-blue>
            </template>
          </popup-modal>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, watch, onMounted, onUnmounted, computed} from 'vue';
  import {useRoute, useRouter}  from "vue-router";
  import {event} from "vue-gtag";
  import {SUBJECT_MAP} from "@/consts/subject";
  import AudioPlayer from '@/consts/sounds';
  import remove_markdown from "@/util/remove_markdown";
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env"
  import {ISectionProgress} from "@/consts/interfaces";
  import {STUDY_TARGET_KIND, REVIEW_REQUIRED} from "@/consts/study";
  import HomeworkInfo from "@/util/homework-info";
  import {findSectionByChapterId} from "@/util/extract-section-data"
  import { useAccountStore } from '@/store/student/account_store';
  import { useWorkStore } from '@/store/student/work_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useHomeworkStore } from '@/store/student/homework_store';
  import { saveInitialStudyBreakData } from '@/util/study_break_data';
  import local_time from '@/util/datetime';
  import { getLatestBreakDataVersion } from '@/consts/break_data_version'
  import { createLatestQuestionHistories } from '@/util/create-lastest-qhistories';

  const audioPlayer = AudioPlayer.getInstance()
  const route = useRoute()
  const router = useRouter()
  const refSection = ref([])
  const refChapterAccordion = ref([])
  const accountStore = useAccountStore()
  const workStore = useWorkStore()
  const globalNavigationStore = useGlobalNavigationStore()
  const homeworkStore = useHomeworkStore()
  const chapter_id = ref(0);
  const questionModal = ref(false);
  const interruptionModal = ref(false);
  const disabledLearning = ref(false);
  const reviewTagModal = ref(false);
  const sectionTagModal = ref(false);
  const sectionReviewTitle = ref("")
  const sectionReviewSortOrder = ref(0)
  const sectionReviewQuestionLen = ref(0)
  const selectedQuestionSet = ref<any>({})
  const selectedSection = ref<any>({})
  const unansweredQuestion = ref([])
  const isAnimation = ref(false)
  const localAnimationId = ref(0)
  const refresh_timer = ref(null)
  const learningStartPage = {
    name: route.name,
    path: route.path,
    params: route.params,
  }
  // show only review question_set flag
  const isReviewOnly = ref(false)

  onMounted(() => {
    // 内側のスクロールがあるS3-7,8,9画面から戻る時は外側(body)スクロール禁止するクラスを削除する（ipadの不具合）
    let body_tag = document.getElementsByTagName('body')[0]
    body_tag.classList.remove("unscrollable")

    workStore.saveMission(null)
    chapter_id.value = parseInt(route.params.chapter_id as string)
    if(workStore.learningStartPage && workStore.learningStartPage.name=='chapter' && !workStore.isPrevQuestionHistory){
      isAnimation.value = true
    }
    workStore.saveIsPrevQuestionHistory(false)
    homeworkStore.saveIsHomework(false)
    localAnimationId.value = workStore.animationId
    const progress = workStore.sectionProgress[localAnimationId.value]
    // 進行状況が100％で星メダルが三つの場合、または出題単位問題を解いて「次の問題へ」を押した場合はアニメーション表示しない
    if((progress && progress.progress == 100 && progress.number_of_starmedal == 3) || route.params.questionModal){
      isAnimation.value = false
    }
    // NFR-4440 chapter画面を再ロードする時ナビゲーションメニューで該当する教科が選択したままを維持するためsessionに保存した値を設定
    const select_menu = sessionStorage.getItem("selectedMenu")
    globalNavigationStore.saveSelectedMenu(select_menu)
    // NFR-4440 ワーク/ワークAPIの値が取得したら画面レンダリングで必要な処理を行う。
    if(workStore.isValidWorks){
      renderingData()
    }
    // track browser back button
    window.addEventListener('popstate', browserBackHandler );
  })
  async function showAnimation(){
    // NFR-5522 現在のアニメーションIDに基づく進捗を取得
    const currentWorkStoreProgress = workStore.sectionProgress[localAnimationId.value]
    if(!currentWorkStoreProgress){
      return
    }
    let updatedSectionProgress: {[id: string] : ISectionProgress} = await workStore.fetchSectionProgress({
        "chapter_id": chapter_id.value,
        "animation": true
    })
    return new Promise(async(resolve, reject) => {
      const chapterAccRef = refChapterAccordion.value[localAnimationId.value]
      const sectionRef = refSection.value[localAnimationId.value]
      // NFR-5522 新しい進捗が存在し、かつ現在の進捗が存在する場合
      if(updatedSectionProgress[localAnimationId.value] && currentWorkStoreProgress){
        if(updatedSectionProgress[localAnimationId.value].progress > currentWorkStoreProgress.progress
            || updatedSectionProgress[localAnimationId.value].number_of_starmedal > currentWorkStoreProgress.number_of_starmedal){
              sectionRef?.scrollIntoView({behavior: "smooth"})
        }
        chapterAccRef?.refProgressBar?.animate(updatedSectionProgress[localAnimationId.value].progress).then(async()=>{
          workStore.saveSectionProgress(updatedSectionProgress)
          if(updatedSectionProgress[localAnimationId.value].number_of_starmedal==3){
            refresh_timer.value = setTimeout(()=>{
              sectionRef?.classList.add("is-clear")
            }, 200)
          }else {
            sectionRef?.classList.remove("c-question__item--clear")
          }
          resolve(true)
        })
      }else{
        workStore.saveSectionProgress(updatedSectionProgress)
        sectionRef?.classList.remove("c-question__item--clear")
        resolve(true)
      }
    })
  }
  function isAnimated(chapter_id){
    return isAnimation.value && localAnimationId.value == chapter_id;
  }

  async function browserBackHandler(event: any) {
    // browser back control for learning state
    if(event.currentTarget.location.pathname == "/student/answer"){
      window.history.forward()
    }
    let work_id: number | undefined = workStore.selectedWork[workStore.selectedWorkIndex]?.id
    // for the reason of fetch work page chapter progress bar process
    if (work_id){
      await workStore.fetchChapterProgress({"work_id": work_id,})
      await workStore.fetchNextQuestionSet({"work_id": work_id})
    }
    workStore.saveLoading(true)
  }
  onUnmounted(() => {
    // NFR-5175 学習モード以外のみprogressをリセットする。
    if(!workStore.isLearningMode){
      // NFR-5175 chapterページが破棄されたらprogress stateを初期化する。
      workStore.resetSectionProgress()
    }
    window.removeEventListener('popstate', browserBackHandler, false);
    clearTimeout(refresh_timer.value)
    // NFR-5456: reset last learned question_set_id if leave the page
    workStore.saveLastLearningQuestionSetId(null)
  })

  const nextQuestionSection = computed(() => {
    return workStore.sections.filter(item => {
      return workStore.nextQuestionSet.section_id == item.id
    })
  })
  const workTitle = computed(() => {
    if(workStore.selectedWork.length>0){
      return workStore.selectedWork[workStore.selectedWorkIndex].name
    }
    return ""
  })
  const getSubjectFieldName = computed(() => {
    if(workStore.selectedWork.length>0){
      return workStore.selectedWork[workStore.selectedWorkIndex].subject_field
    }
    return ""
  })
  const getAcademicYear = computed(() => {
    if(workStore.selectedWork.length>0){
      return workStore.selectedWork[workStore.selectedWorkIndex].academic_year
    }
    return ""
  })
  const getChapter = computed(() => {
    if(workStore.selectedWork.length>0){
      for(let part of workStore.selectedWork[workStore.selectedWorkIndex].parts){
        for(let chapter of part.chapters){
          if(chapter.id == parseInt(route.params.chapter_id as string)){
            return chapter
          }
        }
      }
    }
    return {
      index_label: "",
      title: ""
    }
  })
  const questionSetDisplayName = computed(() => {
    return selectedQuestionSet.value.question_set_label?.display_name
  })
  // 選択した出題単位が宿題対象かチェック
  const homeworkQuestionset = computed(() => {
    if(selectedQuestionSet.value){
      return homeworkStore.homeworkQuestionSets.some(h => selectedQuestionSet.value.id == h.question_set_id)
    }
  })
  // 出題単位に表示する宿題情報取得
  const homeworkInfo = computed(() => {
    if(selectedQuestionSet.value){
      const hwInfo = new HomeworkInfo(selectedQuestionSet.value.id, homeworkStore.homeworkQuestionSets)
      return hwInfo.info;
    }
    return [];
  })
  // NFR-5456: filter review toggle
  const getSections = computed(() => {
    if(isReviewOnly.value){
      const review_question_set_ids = new Set(workStore.reviewTags.map(item => item.question.question_set_id))
      return workStore.sections.filter(section => section.question_sets.some(question_set => review_question_set_ids.has(question_set.id))).map(section => ({
        ...section,
        question_sets: section.question_sets.filter(question_set => review_question_set_ids.has(question_set.id))
      }))
    } else {
      return workStore.sections
    }
  })
  // NFR-5456: toggle show review only question
  function reviewToggleSwitch() {
    isReviewOnly.value = !isReviewOnly.value
  }
  function accordionIsOpen(s_id: number){
    // fetch the section_id is open or not
    let section_id = workStore.accordionBySectionId[s_id]
    // check section_id is in last session or not
    if(section_id !== undefined){
      return section_id ? s_id : null;
    }
    // if no session data then get the last learning section
    return workStore.latestSection.id
  }
  function saveAccordion(payload: {section_id: number, value: boolean}){
    workStore.saveAccordionBySectionId(payload)
  }
  function openReviewTagModal(){
    if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
    disabledLearning.value = false
    workStore.saveRemainQuestion([])
    workStore.saveIsReviewQuestion(true)
    workStore.saveIsChapterReview(true)
    workStore.saveIsMissionQuestion(false)
    workStore.saveIsUnanswered(false)
    workStore.saveIsWronglyAnswered(false)
    reviewTagModal.value = true
    let questions: Array<any> = []
    let question_ids: Array<number> = []
    workStore.reviewTags.forEach(item =>{
      questions.push(item.question)
      question_ids.push(item.question.id)
    })
    // find unanswered question
    let unanswered: Array<any> = []
    for(let qus of questions){
      if(!workStore.answeredQuestionIds.includes(qus.id)){
        unanswered.push(qus)
      }
    }
    unansweredQuestion.value = unanswered

    if(question_ids.length > 15){
      workStore.saveTotalNumOfQuestion(10)
      workStore.saveQuestionIds(question_ids.splice(0, 10))
      workStore.saveQuestions(questions.splice(0, 10))
      workStore.saveRemainQuestion(questions)
    }else{
      workStore.saveTotalNumOfQuestion(question_ids.length)
      workStore.saveQuestionIds(question_ids)
      workStore.saveQuestions(questions)
    }
    let question_sets: any = {}
    for(let section of workStore.sections){
      section.question_sets.forEach(item => question_sets[item.id]=item)
    }
    workStore.saveSelectedQuestionSet(question_sets)
    disabledLearning.value = true
  }
  function openSectionReview(section){
    if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
    workStore.saveRemainQuestion([])
    workStore.saveAnimationId(section.id)
    disabledLearning.value = false
    workStore.saveIsReviewQuestion(true)
    workStore.saveIsChapterReview(false)
    workStore.saveIsMissionQuestion(false)
    workStore.saveIsUnanswered(false)
    workStore.saveIsWronglyAnswered(false)
    sectionTagModal.value = true
    sectionReviewQuestionLen.value = countReview(section.id)
    sectionReviewTitle.value = section.title
    sectionReviewSortOrder.value = section.sort_order
    let questions: Array<any> = []
    let question_ids: Array<number> = []
    workStore.reviewTags.forEach(item =>{
      if(item.question.section_id == section.id){
        questions.push(item.question)
        question_ids.push(item.question.id)
      }
    })
    // find unanswered question
    let unanswered: Array<any> = []
    for(let qus of questions){
      if(!workStore.answeredQuestionIds.includes(qus.id)){
        unanswered.push(qus)
      }
    }
    unansweredQuestion.value = unanswered
    if(question_ids.length > 15){
      workStore.saveTotalNumOfQuestion(10)
      workStore.saveQuestionIds(question_ids.splice(0, 10))
      workStore.saveQuestions(questions.splice(0, 10))
      workStore.saveRemainQuestion(questions)
    }else{
      workStore.saveTotalNumOfQuestion(question_ids.length)
      workStore.saveQuestionIds(question_ids)
      workStore.saveQuestions(questions)
    }
    let question_sets: any = {}
    section.question_sets.forEach(item => question_sets[item.id]=item)
    workStore.saveSelectedQuestionSet(question_sets)
    disabledLearning.value = true
  }
  async function openInterruptionModal({section, question_set}) {
    selectedQuestionSet.value = question_set
    selectedSection.value = section
    interruptionModal.value = true
  }
  async function openModal({section, question_set, isQuestionModal=true}){
    interruptionModal.value = false
    if(accountStore.isSoundEnabled && isQuestionModal){audioPlayer.startSound().play()}
    workStore.saveAnimationId(section.id)
    workStore.saveIsReviewQuestion(false)
    workStore.saveIsMissionQuestion(false)
    workStore.saveIsUnanswered(false)
    workStore.saveIsPrevQuestionHistory(false)
    workStore.saveIsWronglyAnswered(false)
    sectionReviewSortOrder.value = section.sort_order
    selectedQuestionSet.value = question_set
    selectedSection.value = section
    workStore.saveSelectedQuestionSet({[question_set.id]:question_set})
    questionModal.value = isQuestionModal
    disabledLearning.value = false
    await workStore.fetchQuestions({"question_set_id": question_set.id})
    await workStore.fetchLatestQuestionHistories({"question_set_id": question_set.id})
    // find unanswered questions
    let questions: Array<any> = []
    let count:number = 0
    for(let question of workStore.questions){
      count++
      if(!workStore.answeredQuestionIds.includes(question.id)){
        questions.push(question)
      }
    }
    workStore.saveTotalNumOfQuestion(count)
    unansweredQuestion.value = questions
    disabledLearning.value = true
  }
  function closeModal(modal){
    if(disabledLearning.value == false){
      return
    }
    if(accountStore.isSoundEnabled){audioPlayer.closeSound().play()}
    workStore.saveAnimationId(0)
    if(modal == 'reviewTag'){
      reviewTagModal.value = false
    }else if(modal == 'sectionReviewTag'){
      sectionTagModal.value = false
    }
    else{
      questionModal.value = false
    }
  }
  function closeQuestionLayer(){
    if(disabledLearning.value == false){
      return
    }
    questionModal.value = false
  }
  const getChapterIndexTitle = computed(() => {
    let chapter = getChapter.value
    return chapter.index_label + "　" + chapter.title
  })
  const numOfQuestion = computed(() => {
    return workStore.reviewTags.length
  })
  function lastStudy(section_id, qs_id){
    if(workStore.sectionProgress[section_id]){
      const question_set: Array<any> = workStore.sectionProgress[section_id].question_sets.filter(item=>{
          return item.id == qs_id
      })
      if(question_set.length>0 && question_set[0].latest_question_set_history){
        return question_set[0].latest_question_set_history
      }
    }
    return {
      "last_studied_at": "",
      "progress_stars": 0
    }
  }
  function countReview(section_id){
    return workStore.reviewTags.filter(item => item.question.section_id == section_id).length
  }
  function isReview(qs_id){
    const review_tag = workStore.reviewTags.filter(item => item.question.question_set_id == qs_id)
    return review_tag.length
  }
  function solveUnansweredQuestion(){
    workStore.saveIsUnanswered(true)
    workStore.saveIsWronglyAnswered(false)
    let question_ids:Array<number> = []
    if(unansweredQuestion.value.length>15){
      for(let i=0; i<10; i++){
        question_ids.push(unansweredQuestion.value[i].id)
      }
      workStore.saveQuestions(unansweredQuestion.value.splice(0, 10))
    }else{
      unansweredQuestion.value.forEach(question => question_ids.push(question.id))
      workStore.saveQuestions(unansweredQuestion.value)
    }
    workStore.saveQuestionIds(question_ids)
    startLearning(STUDY_TARGET_KIND.LEARN_UNANSWERED_QUESTIONS)
  }
  function solvedReviewRequired(){
    workStore.saveIsReviewQuestion(true)
    let questions: Array<any> = []
    let question_ids: Array<number> = []
    workStore.reviewTags.forEach(review => {
      if(review.question.question_set_id == selectedQuestionSet.value.id){
        questions.push(review.question)
        question_ids.push(review.question.id)
      }
    })
    if(questions.length>0){
      workStore.saveQuestions(questions)
      workStore.saveQuestionIds(question_ids)
      workStore.saveTotalNumOfQuestion(question_ids.length)
      startLearning(STUDY_TARGET_KIND.LEARN_REVIEW_REQUIRED_QUESTIONS, REVIEW_REQUIRED.QUESTION_SET_REVIEW)
    }
  }
  async function startInterruptDataLearning() {
    await openModal({section: selectedSection.value, question_set: selectedQuestionSet.value, isQuestionModal: false})
    startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, REVIEW_REQUIRED.NOT_REVIEW_REQUIRED, true)
  }
  function startLearning(study_target_kind:number=STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, review_kind=REVIEW_REQUIRED.NOT_REVIEW_REQUIRED, isInterrupt=false){
    workStore.saveQIdx(0)
    if(disabledLearning.value && workStore.questionIds.length>0){
      workStore.saveIsLearningPage(true)
      workStore.saveIsLearningMode(true)
      workStore.saveLearningStartPage(learningStartPage)
      if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
      let questionCorrectWrongList = workStore.questionIds.map((item) => {
        return {
          result: null,
          progress: 0
        }
      })
      workStore.fetchQuestionProgress({question_ids: workStore.questionIds})
      workStore.initializeAnswer()
      workStore.saveNextQuestionSet(null)
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('start_study', {
          'subject_field': workStore.selectedWork[workStore.selectedWorkIndex].subject_field,
          'study_target_kind': study_target_kind,
          'review_kind': review_kind,
          'work_id': workStore.selectedWork[workStore.selectedWorkIndex]?.id,
          'target_question_count': questionCorrectWrongList.length
        })
      }
      // NFR-5524: start last interruption
      if(isInterrupt){
        // NFR-5868: getting the interruption data
        const break_data = workStore.study_break_data[workStore.selectedWorkId]?.break_data
        workStore.saveIsWronglyAnswered(true)
        questionCorrectWrongList = break_data?.correct_wrong_list
        // NFR-5868: ensure to save initialAnswer as an array
        workStore.saveInitializeAnswer(break_data?.saved_answers || [])
        // NFR-5118: getting interruption question index
        const current_question_index = break_data?.interrupt_index
        // NFR-5118: getting the last interrupt path
        const interrupt_path = break_data?.interrupt_path
        workStore.saveQIdx(current_question_index)
        const created_at = break_data?.data_created_at
        const updated_at = local_time()
        study_target_kind = break_data?.study_target
        // NFR-5679 initialAnswerの長さがquestionsの長さと一致しない場合には該当するquestionsを取得して再保存処理を行う。
        if(workStore.initialAnswer.length !== workStore.questions.length){
          const initial_question_ids = workStore.initialAnswer.map(answer=> answer.question_id)
          const filtered_questions = workStore.questions.filter(question => initial_question_ids.includes(question.id))
          workStore.saveQuestionIds(initial_question_ids)
          workStore.saveQuestions(filtered_questions)
        }
        // NFR-5116: initilize study break data when resume learning
        saveInitialStudyBreakData(workStore, selectedQuestionSet.value.id, questionCorrectWrongList, created_at, updated_at, null, getLatestBreakDataVersion(), study_target_kind, current_question_index)
        workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
        // 中断して再開する時が未正解問題を解くの場合
        if(study_target_kind && study_target_kind === STUDY_TARGET_KIND.LEARN_UNANSWERED_QUESTIONS){
          // NFR-5679 study_targetが未正解問題を解くの場合はis_unanswered stateをtrueに変更する（S3-10結果画面の数字が正しく表示するため）
          workStore.saveIsUnanswered(true)
          // NFR-5442 中断して再開する時、正答済みの解答欄はDBに保存しないようにする。（S3-10の誤答のみ解くと同じ仕様にする）
          workStore.initialAnswer.forEach(answer => {
            answer.quiz_histories.forEach(quiz => {
                quiz.is_first_correct_answer = quiz.is_correct_answer;
            });
          });
        }
        router.push({name:`${interrupt_path}`})
      } else {
        // NFR-5116: initilize study break data
        saveInitialStudyBreakData(workStore, selectedQuestionSet.value.id, questionCorrectWrongList, local_time(), null, null, getLatestBreakDataVersion(), study_target_kind)
        workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
        router.push({name:'question'})
      }
    }
  }
  function goBack(){
    let subject_name: string = workStore.selectedWork[workStore.selectedWorkIndex].subject.name
    router.push({path: `/student/work/${SUBJECT_MAP[subject_name]}`}).catch(err => {})
  }
  function showQuestionHistories(review_kind: number){
    if(disabledLearning.value == false || workStore.latestQuestionHistories.length == 0){
      return
    }
    if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
    // initialize all question answer
    workStore.initializeAnswer()
    workStore.saveIsDisabledButton(false)
    workStore.saveIsLearningPage(true)
    workStore.saveIsLearningMode(true)
    workStore.saveQIdx(0)
    workStore.saveIsPrevQuestionHistory(true)
    workStore.saveLearningStartPage(learningStartPage)
    const questionCorrectWrongList = createLatestQuestionHistories();
    if(isEnvCaptureGoogleAnalyticsEvents()){
      event('start_study', {
        'subject_field': workStore.selectedWork[workStore.selectedWorkIndex].subject_field,
        'study_target_kind': STUDY_TARGET_KIND.CHECK_RESULT_PREVIOUS_STUDY,
        'review_kind': review_kind,
        'work_id': workStore.selectedWork[workStore.selectedWorkIndex]?.id,
        'target_question_count': questionCorrectWrongList.length
      })
    }
    // reset router transit time for history check
    workStore.saveTransitTime(0)
    router.push({name:'answer'})
  }
  async function renderingData(){
    await homeworkStore.fetchHomeworkQuestionSet()
    const sectionData =  findSectionByChapterId(workStore.works, chapter_id.value)
    workStore.saveSections(sectionData)
    let work:Array<any>= []
    for(let item of workStore.works){
      for(let part of item.parts){
        for(let chapter of part.chapters){
          if(chapter.id == chapter_id.value){
            work.push(item);
            break;
          }
        }
        if(work.length>0){
          break
        }
      }
      if(work.length>0){
        break
      }
    }
    if(work.length>0){
      let work_id: number = work[0].id
      work = workStore.workBySubName[SUBJECT_MAP[work[0].subject.name]]
      let current_work_index: number = work.findIndex(item => item.id === work_id)
      globalNavigationStore.saveSelectedMenu(SUBJECT_MAP[work[current_work_index].subject.name])
      workStore.saveSubField(work[current_work_index].subject_field)
      workStore.saveSelectedWorkIndex(current_work_index)
      workStore.saveSelectedWork(work)
    }
    let question_set_ids: Array<number> = []
    document.title = remove_markdown(getChapterIndexTitle.value) + " | " + remove_markdown(workTitle.value)
    // animationがtrueで出題単位問題を解いて「終わる」ボタンを押した場合
    if (isAnimation.value && !route.params.questionModal) {
      await showAnimation()
    }else{
      await workStore.fetchSectionProgress({"chapter_id": chapter_id.value})
    }
    // 出題単位の問題を解いて「次の問題へ」を押した場合
    if(route.query.p === "openModal" && workStore.nextQuestionSet){
      question_set_ids.push(workStore.nextQuestionSet.id)
      const sectionData =  findSectionByChapterId(workStore.works, workStore.nextQuestionSet.chapter_id)
      workStore.saveSections(sectionData)
      const section = nextQuestionSection.value
      if(section.length>0){
        await openModal({section: section[0], question_set: workStore.nextQuestionSet})
      }
    }else{
      workStore.saveAnimationId(0)
    }
    if(workStore.sections.length==0){
      router.replace({name: "pageNotFound"})
    }
    for(let section of workStore.sections){
      section.question_sets.forEach(item => question_set_ids.push(item.id))
    }
    // for getting unanswered question
    workStore.fetchQuestionSetProgress({question_set_ids: question_set_ids})
    workStore.saveLearningStartPage(null)
    // NFR-4440 chapter画面のurlからchapter_idを変更して移動する場合ナビゲーションメニューも変更する必要があるためsessionに再設定
    sessionStorage.setItem("selectedMenu", globalNavigationStore.selectedMenu)
  }
  watch(
    () => workStore.works,
    (newVal) => {
      // NFR-4440 ワーク/ワークAPIの値を監視してある場合のみ画面レンダリングで必要な処理を行う。
      if(newVal){
        renderingData()
      }
    }
  )
</script>